<lib-form-field-container [kind]="FormContainerKind.SegmentedButton">
    <ng-content
        label
        select="[label]"></ng-content>

    <ng-content
        supportingText
        select="[supportingText]"></ng-content>

    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <div class="v3">
        <div
            class="sb-segmented-button"
            role="group"
            [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
            [ngClass]="{ 'sb-segmented-button-disabled': formControl.disabled && !formControl.isViewOnly, 'sb-segmented-button-view-only': formControl.isViewOnly }">
            @for (item of itemList; track item) {
                <div
                    class="sb-segmented-button-item"
                    [attr.tabindex]="formControl.disabled ? null : 0"
                    [ngClass]="{ 'sb-segmented-button-item-selected': item.value === formControl.value, 'sb-segmented-button-item-divider': !$last }"
                    (click)="ChangeEvent(item.value)"
                    (keydown.enter)="ChangeEvent(item.value)"
                    (keydown.space)="ChangeEvent(item.value)">
                    <div class="sb-segmented-button-item-wrapper">
                        @if (item.value === formControl.value) {
                            <lib-icon
                                [icon]="Icon.Common.Check"
                                [size]="IconSize.ExtraSmall"></lib-icon>
                        }
                        <p>
                            <ng-container *ngTemplateOutlet="item.label"></ng-container>
                        </p>
                    </div>
                </div>
            }
        </div>
    </div>
</lib-form-field-container>
